import { string } from 'yup';
import { mapEnum } from 'utils/global';

export const enumerable = (enumType: { [s: string]: string }) =>
  string().nullable().oneOf(mapEnum(enumType));
